import { every, some } from "lodash";
import {
  SIDER_TOGGLE,
} from "./../action";
import { treeToArr } from "./../../utils";


interface defaultStateProps {
  siderCollapsed: boolean;
}

const defaultState: defaultStateProps = {
  siderCollapsed: false,
};

export const common = (state = defaultState, action: any) => {
  switch (action.type) {
    case SIDER_TOGGLE:
      state = { ...state };
      state.siderCollapsed = !state.siderCollapsed;
      break;
    default:
      break;
  }
  return state;
};
